import { MajorExplorerCapabilityConfiguration } from '../../../src/configuration';
import { MajorProgram } from '../../../src/data/builders/major_programs_builder';
import { MajorTileFunction } from '../../../src/data/functions/major_tile_fn';

export class MajorDetailController {
  private iconTheme: string;

  constructor(
    private chosenMajor: MajorProgram,
    private majorTileFn: MajorTileFunction,
    private ngMajorExplorerCapabilityConfiguration: MajorExplorerCapabilityConfiguration
  ) {
    this.iconTheme = this.ngMajorExplorerCapabilityConfiguration.config.navIconTheme;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/views/major_detail/major_detail_controller.ts